import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";

const ModalStatusDay = ({
  show,
  setShow,
  startDateStatus,
  handleStartDateStatusChange,
  setStartDateStatus
}) => {
  return (
    <>
      <Modal show={show} backdrop="static">
        <Modal.Header className="py-3 d-flex justify-content-between">
          <h5 className="mb-0">Establecer Fecha de Corte</h5>
          <Button
            onClick={(e) => {
              setShow(false);
            }}
            variant="light"
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form onSubmit={(e)=>handleStartDateStatusChange(e,startDateStatus)}>
              <Row className="d-flex align-items-center">
                <Col md={4}>
                  <Form.Label className="mb-0">Fecha de Corte:</Form.Label>
                </Col>
                <Col md={8}>
                  <ReactDatePicker
                    selected={startDateStatus}
                    /* onChange={handleStartDateStatusChange} */
                    onChange={(date)=>setStartDateStatus(date)}
                    dateFormat="dd-MM-yyyy"
                    className="form-control w-100"
                    locale="es"

                    //excludeDates={excludedDates.current}
                  />
                </Col>
              </Row>
              <div className="d-flex mt-5 justify-content-end">
                <Button variant="success" type="submit" block>
                  Guardar
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalStatusDay;
